import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  flex-direction: row;
  @media (max-width: 324px){
    flex-direction: column;
    justify-content: center;
  }
`;

export const Title = styled.div`
  font-size: 12px;
  color: #000FFF;
  font-weight: bold;
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 12px;
  font-weight: 300;
`;

export const Left = styled.div`
  margin-left: 10px;
  display:flex;
  flex-direction: column;
`

export const Middle = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 324px){
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
`

export const Right = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  width: 40%;
`

export const Details = styled.div`
  padding: 0px;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}


export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const PixContainer = styled.div`
  padding-right: 0;
`;

export const PixIcon = {
  padding:0
}

